export default __webpack_public_path__ + "static/media/02.49dee8a8.jpg";